import React, { useEffect } from 'react';
import CurrentChat from './components/CurrentChat/CurrentChat';
import ChatHistory from './components/ChatHistory/ChatHistory';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { closeFileExplorer } from '../../store/app/slice';
import { closeMobileHistory, updateFormValues } from '../../store/chat/slice';
import styles from './ChatPage.module.scss';
import RenameConversationModal from './components/ChatHistory/components/RenameConversationModal';
import DeleteConversationModal from './components/ChatHistory/components/DeleteConversationModal';
import CompanyFilesLayout from '../../components/layout/CompanyFilesLayout/CompanyFilesLayout';

const ChatPage = () => {
  const dispatch = useAppDispatch();
  const { isMobile } = useAppSelector((state) => state.app);
  const { isMobileHistoryOpen, conversation } = useAppSelector((state) => state.chat);
  const { documentId } = useAppSelector((state) => state.document);
  const { selectedCompanies } = useAppSelector((state) => state.company);

  // when not in conversation, reflect selected companies into filtered company ids
  // so that new conversation is filtered by those companies
  useEffect(() => {
    const hasActiveConversation = !!(
      conversation &&
      conversation.messages &&
      conversation.messages.length > 0
    );
    if (!hasActiveConversation) {
      const companyIds = selectedCompanies.map((c) => c.id);
      dispatch(updateFormValues({ filteredCompanyIds: companyIds }));
    }
  }, [conversation, selectedCompanies, dispatch]);

  return (
    <div className={`${styles['app-container']} ${documentId ? styles['with-document'] : ''}`}>
      <div className={styles['chat-interface-container']}>
        <div className={styles['content-container']}>
          <CompanyFilesLayout
            searchText="Search for companies to ask questions about them"
            embeddedOnlyTicker
            leftSidebar={
              <div
                className={`${styles['history-container']} ${
                  isMobile && isMobileHistoryOpen ? styles['mobile-visible'] : ''
                }`}
              >
                <ChatHistory onClose={() => dispatch(closeMobileHistory())} isMobile={isMobile} />
              </div>
            }
            main={<CurrentChat />}
          />
        </div>
      </div>

      {isMobile && isMobileHistoryOpen && (
        <div
          className={`${styles.backdropOverlay} ${styles.visible}`}
          onClick={() => {
            dispatch(closeMobileHistory());
            dispatch(closeFileExplorer());
          }}
        />
      )}

      {/* Modals for conversation management */}
      <RenameConversationModal />
      <DeleteConversationModal />
    </div>
  );
};

export default ChatPage;
